<!-- Responsibility: Present the invitee BYOK setup entrypoint for the welcome surface.
Scope: Setup copy and CTA only; provider configuration logic lives in the owning screen. -->
<welcome-setup-wizard>
  <section class="setup-wizard">
    <header class="section-head">
      <p class="eyebrow">SETUP WIZARD</p>
      <h3>Bring your own key, keep it in the browser.</h3>
      <p>The cleanest way to start is to wire a provider once and return here with your own AI access ready.</p>
    </header>

    <ol class="setup-steps" aria-label="BYOK setup steps">
      <li>Open the settings dialog.</li>
      <li>Choose Ollama, Gemini, or another provider you trust.</li>
      <li>Save the key locally in this browser.</li>
    </ol>

    <p class="setup-note">AnyQuest keeps your keys in your browser. Nothing here requires a hidden setup maze.</p>

    <button type="button" class="action-btn primary" onclick={ openSetup }>
      SET UP BYOK
    </button>
  </section>

  <script>
    export default {
      openSetup() {
        this.props.actions?.openSetup?.()
      },
    }
  </script>

  <style>
    welcome-setup-wizard {
      display: block;
    }

    welcome-setup-wizard .setup-wizard {
      display: grid;
      gap: var(--space-sm);
      padding: var(--space-lg);
      border: 1px solid color-mix(in srgb, var(--border) 52%, transparent);
      border-radius: var(--radius-lg);
      background:
        radial-gradient(circle at top right, color-mix(in srgb, var(--brand-primary) 10%, transparent), transparent 28%),
        color-mix(in srgb, var(--surface) 76%, transparent);
      box-shadow: inset 0 1px 0 color-mix(in srgb, var(--text-prose) 10%, transparent);
    }

    welcome-setup-wizard .section-head {
      display: grid;
      gap: var(--space-xs);
    }

    welcome-setup-wizard .eyebrow {
      margin: 0;
      color: var(--gold);
      font-size: var(--type-xs);
      letter-spacing: 0.18em;
      text-transform: uppercase;
    }

    welcome-setup-wizard h3 {
      margin: 0;
      color: var(--text-prose);
      font-size: var(--type-lg);
      line-height: 1.12;
    }

    welcome-setup-wizard .section-head p,
    welcome-setup-wizard .setup-note {
      margin: 0;
      color: var(--text-dim);
      line-height: 1.55;
    }

    welcome-setup-wizard .setup-steps {
      display: grid;
      gap: var(--space-xs);
      margin: 0;
      padding-left: 1.1rem;
      color: var(--text-prose);
      line-height: 1.5;
    }

    welcome-setup-wizard .setup-note {
      color: color-mix(in srgb, var(--text-dim) 82%, var(--gold));
      font-size: var(--type-sm);
    }

    welcome-setup-wizard .action-btn {
      width: fit-content;
    }
  </style>
</welcome-setup-wizard>
